import { Box, Text, Flex, Button, Icon } from '@chakra-ui/react';
import { useGetBluePrintQuery } from '@/store/query/blueprint';
import { useState } from 'react';
import Empty from '@/assets/icons/colored/Empty';
import { getBg } from '../../../../outreach-images';

const Blueprint = ({
  blueprint = {},
  onPreview = () => {},
  onCreate = () => {},
}) => {
  const [fetch, setFetch] = useState(false);
  const bg = getBg({ key: blueprint?.image_key });
  const { data: blueprintData } = useGetBluePrintQuery(
    {
      blueprintId: blueprint?.id,
    },
    { skip: !fetch }
  );

  return (
    <Box
      data-tracking-id="blueprint"
      data-test-id="blueprint"
      onMouseEnter={() => {
        setFetch(true);
      }}
      pos="relative"
      cursor="pointer"
      h="230px"
      w="360px"
      borderWidth="1px"
      borderColor="border-color"
      mr="24px"
      mb="24px"
      borderRadius="12px"
      overflow="auto"
      role="group"
    >
      <Box h="150px" bgImage={bg} bgSize="360px 150px" p="16px">
        <>
          {blueprint?.from_kula ? (
            <Box
              as="span"
              bg="#E8DAFF"
              color="#6929C4"
              borderRadius="12px"
              p="5px 16px"
              fontWeight="semiBold"
              fontSize="12px"
              mr="4px"
            >
              Kula
            </Box>
          ) : (
            <Box
              fontWeight="semiBold"
              fontSize="12px"
              as="span"
              bg="#E8DAFF"
              color="#6929C4"
              borderRadius="12px"
              p="5px 16px"
              mr="4px"
            >
              Org
            </Box>
          )}
        </>
        <>
          {blueprint?.tag_names?.length > 0 &&
            blueprint?.tag_names?.map((tag, idx) => (
              <Box
                key={idx}
                fontWeight="semiBold"
                fontSize="12px"
                as="span"
                bg="#E7FFFE"
                color="#00736C"
                borderRadius="12px"
                p="5px 16px"
                mr="4px"
              >
                {tag}
              </Box>
            ))}
        </>
      </Box>
      <Box p="12px 24px">
        <Text fontWeight="semiBold" fontSize="16px">
          {blueprint?.name}
        </Text>
        <Text variant="muted">{blueprint?.description}</Text>
      </Box>
      <Box
        _groupHover={{ display: 'block' }}
        display="none"
        pos="absolute"
        p="8px"
        bg="white"
        top="0px"
        bottom="0px"
        borderRadius="12px"
        background="white"
        w="100%"
      >
        <Flex
          background="rgba(141, 141, 141, 0.04)"
          backdropFilter="blur(34px)"
          h="100%"
          borderRadius="8px"
          p="16px"
          flexDir="column"
        >
          <Text fontSize="16px" fontWeight="semiBold">
            {blueprint?.name}
          </Text>
          <Text fontSize="12px" variant="muted">
            {blueprint?.description}
          </Text>

          <Flex
            flex="1"
            alignItems="center"
            justifyContent="space-between"
            onClick={() => {
              onPreview(blueprint);
            }}
          >
            <Box>
              <Text fontSize="14px" fontWeight="semiBold" textAlign="center">
                {blueprintData?.steps ?? '-'}
              </Text>
              <Text variant="muted" textAlign="center">
                Total Steps
              </Text>
            </Box>
            <Box>
              <Text fontSize="14px" fontWeight="semiBold" textAlign="center">
                {blueprintData?.days ?? '-'}
              </Text>
              <Text variant="muted" textAlign="center">
                Days in Sequence
              </Text>
            </Box>
            <Box>
              <Text fontSize="14px" fontWeight="semiBold" textAlign="center">
                {blueprintData?.used ?? '-'}
              </Text>
              <Text variant="muted" textAlign="center">
                Times used
              </Text>
            </Box>
          </Flex>

          <Flex>
            <Button
              mr="24px"
              variant="secondary"
              onClick={() => {
                onPreview(blueprint);
              }}
            >
              Preview
            </Button>
            <Button
              flex="1"
              onClick={() => {
                onCreate(blueprint);
              }}
              id="use-blueprint"
            >
              Use Blueprint
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export const Blueprints = ({
  blueprints = [],
  onPreview = () => {},
  onCreate = () => {},
}) => {
  if (!blueprints?.length) {
    return (
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        flex="1"
      >
        <Icon as={Empty} w="250px" h="250px" />
        <Text fontWeight="medium" fontSize="16px">
          Oops! We couldn’t find what you’re looking for.
        </Text>
      </Flex>
    );
  }

  return (
    <>
      {blueprints?.map((blueprint) => (
        <Blueprint
          key={blueprint.id}
          blueprint={blueprint}
          onPreview={onPreview}
          onCreate={onCreate}
        />
      ))}
    </>
  );
};
